const objectiveItemsPropsMapping = (i18n, permissions) => [
  {
    id: 'WebsiteVisits',
    descriptionLine: i18n.getString(_TL_('Visits to my website')),
    helpId: 'pop_BA_CampaignCreate_Goals_Clicks',
    iconName: 'Click',
    'aria-label': i18n.getString(_TL_('Visits to my website')),
    helpArialLabel: i18n.getString(_TL_('Learn more about Visits to my website')),
    isEnabled: true,
  },
  {
    id: 'LocationVisits',
    descriptionLine: i18n.getString(_TL_('Visits to my business location(s)')),
    helpId: 'pop_BA_CampaignCreate_Goals_Visits',
    iconName: 'PedometerSteps',
    'aria-label': i18n.getString(_TL_('Visits to my business location(s)')),
    helpArialLabel: i18n.getString(_TL_('Learn more about Visits to my business location(s)')),
    isEnabled: true,
  },
  {
    id: 'WebsiteConversions',
    descriptionLine: i18n.getString(_TL_('Conversions in my website')),
    helpId: 'pop_BA_CampaignCreate_Goals_Conversions',
    iconName: 'WebConversion',
    'aria-label': i18n.getString(_TL_('Conversions in my website')),
    helpArialLabel: i18n.getString(_TL_('Learn more about Conversions in my website')),
    isEnabled: true,
  },
  {
    id: 'PhoneCalls',
    descriptionLine: i18n.getString(_TL_('Phone calls to my business')),
    helpId: 'pop_BA_CampaignCreate_Goals_Calls',
    iconName: 'Phone',
    'aria-label': i18n.getString(_TL_('Phone calls to my business')),
    helpArialLabel: i18n.getString(_TL_('Learn more about Phone calls to my business')),
    isEnabled: true,
  },
  {
    id: 'AppInstalls',
    descriptionLine: i18n.getString(_TL_('App installs')),
    helpId: 'pop_BA_CampaignCreate_Goals_Installs',
    iconName: 'CellPhone',
    'aria-label': i18n.getString(_TL_('App installs')),
    helpArialLabel: i18n.getString(_TL_('Learn more about App installs')),
    isEnabled: permissions.IsUserAppInstallAdsAllowed && !permissions.IsDomesticSimplifiedChineseEnabled,
  },
  {
    id: 'SmartCampaign',
    descriptionLine: i18n.getString(_TL_('Smart campaign')),
    helpId: 'pop_BA_CampaignCreate_Goals_Smart',
    iconName: 'Processing',
    'aria-label': i18n.getString(_TL_('Smart campaign')),
    helpArialLabel: i18n.getString(_TL_('Learn more about Smart campaign')),
    isEnabled: permissions.IsSmartCampaignPhase2Enabled && !permissions.IsDomesticSimplifiedChineseEnabled,
  },
  {
    id: 'ShoppingCampaign',
    descriptionLine: i18n.getString(_TL_('Sell products from your catalog')),
    helpId: 'pop_BA_CampaignCreate_Goals_BSC',
    iconName: 'ShoppingCart',
    'aria-label': i18n.getString(_TL_('Sell products from your catalog')),
    helpArialLabel: i18n.getString(_TL_('Learn more about Sell products from your catalog')),
    isEnabled: permissions.IsEnhancedShoppingCampaignAllowed,
    showFACBadge: permissions.dynamic.FACForShopping, // show feature adoption coupon badge: eg. '$25 off'
  },
  {
    id: 'SponsoredShoppingCampaign',
    descriptionLine: i18n.getString(_TL_('Boost product sales')),
    helpId: 'pop_BA_CampaignCreate_Goals_ProductSales',
    iconName: 'RetailFinancials',
    isSVGIcon: false,
    helpArialLabel: i18n.getString(_TL_('Learn more about Boost product sales')),
    'aria-label': i18n.getString(_TL_('Boost product sales')),
    isEnabled: permissions.IsSPAv2Enabled && !permissions.IsDomesticSimplifiedChineseEnabled,
  },
  {
    id: 'MSStoreAds',
    descriptionLine: i18n.getString(_TL_('Promote your apps and games')),
    helpId: 'pop_BA_CampaignCreate_Goals_StoreAds',
    iconName: 'MicrosoftStore',
    isSVGIcon: true,
    helpArialLabel: i18n.getString(_TL_('Learn more about Microsoft Store ads')),
    'aria-label': i18n.getString(_TL_('Promote your apps and games')),
    isNewFeature: true,
    isEnabled: (!permissions.IsDomesticSimplifiedChineseEnabled && permissions.IsEnhancedShoppingCampaignAllowed) || (permissions.IsDomesticSimplifiedChineseEnabled && permissions.dynamic.WindowsStoreAdsCNExpansion),
  },
  {
    id: 'VideoCampaign',
    descriptionLine: permissions.dynamic.XandrVideoCampaigns ? i18n.getString(_TL_('Video views')) : i18n.getString(_TL_('Video views')),
    helpId: permissions.dynamic.XandrVideoCampaigns ? 'pop_BA_VideoAds_About' : 'pop_BA_CampaignCreate_Goals_VideoViews',
    iconName: 'MSNVideos',
    helpArialLabel: permissions.dynamic.XandrVideoCampaigns ? i18n.getString(_TL_('Learn more about brand awareness video')) : i18n.getString(_TL_('Learn more about video views')),
    'aria-label': permissions.dynamic.XandrVideoCampaigns ? i18n.getString(_TL_('Video views')) : i18n.getString(_TL_('Video views')),
    isNewFeature: true,
    isEnabled: (permissions.IsVideoAdsForCampaignEnabled || permissions.dynamic.XandrVideoCampaigns) && !permissions.IsDomesticSimplifiedChineseEnabled,
  },
  {
    id: 'MediaPackageCampaign',
    descriptionLine: i18n.getString(_TL_('Media deals')),
    helpId: 'pop_BA_VideoAds_MediaDeals',
    iconName: 'MSNVideos',
    helpArialLabel: i18n.getString(_TL_('Learn more about media deals')),
    'aria-label': i18n.getString(_TL_('Media deals')),
    isNewFeature: true,
    isEnabled: permissions.IsDealEnabledForMsAds && !permissions.IsDomesticSimplifiedChineseEnabled,
  },
  {
    id: 'AdImpressions',
    descriptionLine: i18n.getString(_TL_('Ad impressions')),
    helpId: 'pop_BA_CampaignCreate_Goals_AdImpressions', // TODO
    iconName: 'View',
    helpArialLabel: i18n.getString(_TL_('Learn more about ad impressions')),
    'aria-label': i18n.getString(_TL_('Ad impressions')),
    isEnabled: (permissions.IsManualCpmEnabled || permissions.dynamic.XandrDisplayAdsCampaigns) && !permissions.IsDomesticSimplifiedChineseEnabled,
  },
  {
    id: 'HotelBooking',
    descriptionLine: permissions.dynamic.IsRenameHotelToLodgingEnabled ? i18n.getString(_TL_('Increase property bookings')) : i18n.getString(_TL_('Increase hotel bookings')),
    helpId: permissions.dynamic.IsRenameHotelToLodgingEnabled ? 'pop_BA_CampaignCreate_Goals_LodgingBooking' : 'pop_BA_CampaignCreate_Goals_HotelBooking',
    iconName: 'Hotel',
    'aria-label': permissions.dynamic.IsRenameHotelToLodgingEnabled ? i18n.getString(_TL_('Increase property bookings')) : i18n.getString(_TL_('Increase hotel bookings')),
    helpArialLabel: permissions.dynamic.IsRenameHotelToLodgingEnabled ? i18n.getString(_TL_('Learn more about increase property bookings')) : i18n.getString(_TL_('Learn more about increase hotel bookings')),
    isNewFeature: true,
    isEnabled: permissions.dynamic.HotelCampaign && !permissions.IsDomesticSimplifiedChineseEnabled,
  },
];

export const objectivesConfig = ({ i18n, permissions }) => {
  const objectivesItems = objectiveItemsPropsMapping(i18n, permissions);

  return objectivesItems.filter(item => item.isEnabled);
};

export const objectivesForPerfMax = [
  'WebsiteVisits',
  'LocationVisits',
  'WebsiteConversions',
  'PhoneCalls',
  'ShoppingCampaign',
];
